export const BASEURL =
  "https://iac-scrap-be-dot-auspicious-silo-278108.df.r.appspot.com";
// export const BASEURL = "http://34.27.66.151:5000";

export const API_URLs = {
  fetchOperatorTableData: `${BASEURL}/api/v1/parts`,
  inspectPartById: `${BASEURL}/api/v1/inspections`,
  getPartsCount: `${BASEURL}/api/v1/parts/counts`,
  getPartsTimer: `${BASEURL}/api/v1/parts/timer`,
  fetchQualityTableData: `${BASEURL}/api/v1/parts/details`,
  getPartsList: `${BASEURL}/api/v1/parts/list`,
  fetchRecommendedData: `${BASEURL}/api/v1/recommendations`,
  fetchAlertsData: `${BASEURL}/api/v1/alerts/push-notifs`,
  getAccuracyData: `${BASEURL}/api/v1/charts/parts-trend`,
  getSavingsData: `${BASEURL}/api/v1/charts/savings`,
  getScrapData: `${BASEURL}/api/v1/charts/scrap`,
  getContributionData: `${BASEURL}/api/v1/charts/factors/range`,
  getPartById: `${BASEURL}/api/v1/parts`,
  getFactorsData: `${BASEURL}/api/v1/factors/factor-by-contribution-trend`,
  getConfigurationData: `${BASEURL}/api/v1/factors`,
  getFactorsChart: `${BASEURL}/api/v1/charts/factors/actual-values`,
  getControlChart: `${BASEURL}/api/v1/charts/control-chart`,
  getBoxPlotChart: `${BASEURL}/api/v1/charts/summary/dist-box-chart`,
  getPercentChart: `${BASEURL}/api/v1/charts/summary/percent-chart`,
  getRealTimeData: `${BASEURL}/api/v1/realtime/flags/d0f10bbadcb0440880bdd78c11b7b23e`,
  getProductsList: `${BASEURL}/api/v1/products/all-products`,
  verifyEmail: `${BASEURL}/api/v1/users/forgot-password`,
  verifyOtp: `${BASEURL}/api/v1/users/verify-otp`,
  AMLSheetUrl: `${BASEURL}/api/v1/aml/shift-data`,
  recipeUrl: `${BASEURL}/api/v1/aml/recipes`,
  parameterUrl: `${BASEURL}/api/v1/aml/param`,
};
